import { MDCTextFieldHelperText } from '@material/textfield/helper-text'

export default {
  setup() {
    this.textFieldHelperText = new MDCTextFieldHelperText(this.el)
  },
  destroy() {
    this.textFieldHelperText?.destroy()
    this.textFieldHelperText = null
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
